export const ArrowUp = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="#D9D9D9"
      />
      <path
        d="M12.3434 7.00086C12.1521 6.80958 11.842 6.80958 11.6507 7.00086L8.53369 10.1179C8.34241 10.3092 8.34241 10.6193 8.53369 10.8106C8.72497 11.0019 9.03509 11.0019 9.22637 10.8106L11.9971 8.03987L14.7678 10.8106C14.9591 11.0019 15.2692 11.0019 15.4605 10.8106C15.6517 10.6193 15.6517 10.3092 15.4605 10.1179L12.3434 7.00086ZM12.4869 16.6533V7.3472H11.5073V16.6533H12.4869Z"
        fill="black"
      />
    </svg>
  );
};
